import { z } from 'zod'

import { pagedSchema } from '../core'
import { userSchema } from '../users'

const text = z.string().nullish()

/** An account as the backend sends it. `accountType` is SUPPLY_LOGIC, SUPPLIER or CLIENT. */
export const accountSchema = z.object({
  id: z.string(),
  accountName: z.string(),
  accountType: z.string(),
  email: text,
  phoneNumber: text,
  logoUrl: text,
  addressLine1: text,
  city: text,
  state: text,
  postalCode: text,
  country: text,
  isActive: z.boolean().default(true),
  createdBy: text,
  createdAt: z.string(),
  updatedAt: text,
})
export type AccountDto = z.infer<typeof accountSchema>

/** Creating an account also creates its first user, which comes back as `user`. */
export const createdAccountSchema = accountSchema.extend({ user: userSchema.nullish() })
export type CreatedAccountDto = z.infer<typeof createdAccountSchema>

export const accountPageSchema = pagedSchema(accountSchema)

interface AccountFields {
  accountName: string
  accountType: string
  email: string
  phoneNumber: string
  logoUrl?: string
  addressLine1?: string
  city?: string
  state?: string
  postalCode?: string
  country?: string
}

/** POST /api/v1/accounts */
export interface AccountCreateBody extends AccountFields {
  createdBy: string
}

/** PUT /api/v1/accounts/{id} */
export interface AccountUpdateBody extends AccountFields {
  isActive: boolean
}

/** Query-string filters of GET /api/v1/accounts. */
export interface AccountFilters {
  accountType?: string
  isActive?: boolean
  search?: string
}
